module.exports = __webpack_public_path__ + "img/Atlassian_Logo.9854c66e.png";